import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import { createReducer, PayloadAction } from '@reduxjs/toolkit'
import { getAddress as _getAddress } from 'viem'

import {
  //   DEFAULT_ARCHER_ETH_TIP,
  //   DEFAULT_ARCHER_GAS_ESTIMATE,
  //   DEFAULT_ARCHER_GAS_PRICES,
  DEFAULT_DEADLINE_FROM_NOW,
  INITIAL_ALLOWED_SLIPPAGE,
} from '../../constants'
import { COMMON_BASES_IDS } from '../../constants/pinnedTokens'
import { updateVersion } from '../global/actions'
import {
  // SerializedPair,
  // SerializedToken,
  // addSerializedPair,
  // addSerializedToken,
  // removeSerializedPair,
  // removeSerializedToken,
  addCustomToken,
  addCustomTokens,
  addPinnedToken,
  addUserPath,
  clearNotifications,
  createNotification,
  removeCustomToken,
  removePath,
  removePinnedToken,
  resetPath,
  // toggleURLWarning,
  // updateMatchesDarkMode,
  // updateUserArcherETHTip,
  // updateUserArcherGasEstimate,
  // updateUserArcherGasPrice,
  // updateUserArcherTipManualOverride,
  // updateUserArcherUseRelay,
  // updateUserDarkMode,
  updateUserDeadline,
  updateUserDeadlineType,
  updateUserExpertMode,
  updateUserPathType,
  // updateUserFarmFilter,
  // updateUserVaultFilter,
  // updateUserSingleHopOnly,
  updateUserSlippageTolerance,
  updateUserSlippageToleranceType,
} from './actions'

const currentTimestamp = () => new Date().getTime()
/**
 * @param {string}address 
 * @return {string}
 */
function getAddress(address: string) {
  if (address === 'NATIVE') return 'NATIVE'
  return _getAddress(address)
}
export type TokenAsObject = {
  address: string
  chainId: ChainId
  symbol?: string
  name?: string
  decimals: number
}
export type RemoveCustomToken = Pick<TokenAsObject, 'chainId' | 'address'>
export interface WithUserState {
  [path: string]: UserState
}
export interface UserState {
  // the timestamp of the last updateVersion action
  lastUpdateVersionTimestamp?: number
  customTokens: Record<number, Record<string, TokenAsObject>>
  userPath: Record<number, Record<string, TokenAsObject>>
  pinnedTokens: Record<number | string, string[]>
  userPathType: 'auto' | 'custom'
  notifications: Record<string, Record<string, string[]>>
  slippageToleranceType: 'auto' | 'custom'
  //
  //   userDarkMode: boolean | null // the user's choice for dark mode or light mode
  //   userFarmFilter: string | null // ther user's last active farm filter
  //   userVaultFilter: string | null // ther user's last active vault filter
  //   matchesDarkMode: boolean // whether the dark mode media query matches
  userExpertMode: boolean
  //   userSingleHopOnly: boolean // only allow swaps on direct pairs
  // user defined slippage tolerance in bips, used in all txns
  userSlippageTolerance: string
  // deadline set by user in minutes, used in all txns
  userDeadline: number
  userDeadlineType: 'auto' | 'custom'
  //  tokens: {
  //    [chainId: number]: {
  //      [address: string]: SerializedToken
  //    }
  //  }

  //   pairs: {
  //     [chainId: number]: {
  //       // keyed by token0Address:token1Address
  //       [key: string]: SerializedPair
  //     }
  //   }
  //
  timestamp: number
  //   URLWarningVisible: boolean
  //
  //   userArcherUseRelay: boolean // use relay or go directly to router
  //   userArcherGasPrice: string // Current gas price
  //   userArcherETHTip: string // ETH tip for relay, as full BigInt string
  //   userArcherGasEstimate: string // Gas estimate for trade
  //   userArcherTipManualOverride: boolean // is user manually entering tip
}

/**
 * @param {string}token0Address
 * @param {string}token1Address
 * @return {string}
 */
// function pairKey(token0Address: string, token1Address: string) {
//   return `${token0Address};${token1Address}`
// }

export const initialState: UserState = {
  // userDarkMode: null,
  // userFarmFilter: 'all',
  // userVaultFilter: 'all',
  // matchesDarkMode: false,
  userExpertMode: false,
  slippageToleranceType: 'auto',
  // userSingleHopOnly: false,
  userSlippageTolerance: INITIAL_ALLOWED_SLIPPAGE,
  userDeadline: DEFAULT_DEADLINE_FROM_NOW,
  userDeadlineType: 'auto',
  customTokens: {},
  userPath: {},
  userPathType: 'auto',
  pinnedTokens: COMMON_BASES_IDS,
  notifications: {},
  // tokens: {},
  // pairs: {},
  timestamp: currentTimestamp(),
  // URLWarningVisible: true,
  // userArcherUseRelay: false,
  // userArcherGasPrice: DEFAULT_ARCHER_GAS_PRICES[4].toString(),
  // userArcherETHTip: DEFAULT_ARCHER_ETH_TIP.toString(),
  // userArcherGasEstimate: DEFAULT_ARCHER_GAS_ESTIMATE.toString(),
  // userArcherTipManualOverride: false,
}

export default createReducer(
  initialState,
  (builder) =>
    builder
      .addCase(updateVersion, (state) => {
        // slippage isnt being tracked in local storage, reset to default
        // noinspection SuspiciousTypeOfGuard
        // if (typeof state.userSlippageTolerance !== 'number') {
        //   state.userSlippageTolerance = INITIAL_ALLOWED_SLIPPAGE
        // }
        // // deadline isnt being tracked in local storage, reset to default
        // // noinspection SuspiciousTypeOfGuard
        // if (typeof state.userDeadline !== 'number') {
        //   state.userDeadline = DEFAULT_DEADLINE_FROM_NOW
        // }
        state.lastUpdateVersionTimestamp = currentTimestamp()
      })
      // .addCase(updateUserDarkMode, (state, action) => {
      //   state.userDarkMode = action.payload.userDarkMode
      //   state.timestamp = currentTimestamp()
      // })
      // .addCase(updateMatchesDarkMode, (state, action) => {
      //   state.matchesDarkMode = action.payload.matchesDarkMode
      //   state.timestamp = currentTimestamp()
      // })
      .addCase(updateUserExpertMode, (state, action) => {
        state.userExpertMode = action.payload.userExpertMode
        state.timestamp = currentTimestamp()
      })
      // .addCase(updateUserFarmFilter,  (state, action) => {
      //   state.userFarmFilter = action.payload.userFarmFilter
      //   state.timestamp = currentTimestamp()
      // })
      // .addCase(updateUserVaultFilter,  (state, action) => {
      //   state.userVaultFilter = action.payload.userVaultFilter
      //   state.timestamp = currentTimestamp()
      // })
      .addCase(updateUserSlippageTolerance, (state, action) => {
        state.userSlippageTolerance = action.payload.userSlippageTolerance
        state.timestamp = currentTimestamp()
      })
      .addCase(updateUserSlippageToleranceType, (state, action) => {
        state.slippageToleranceType = action.payload.slippageToleranceType
        state.timestamp = currentTimestamp()
      })
      .addCase(updateUserDeadline, (state, action) => {
        state.userDeadline = action.payload.userDeadline
        state.timestamp = currentTimestamp()
      })
      .addCase(updateUserDeadlineType, (state, action) => {
        state.userDeadlineType = action.payload.userDeadlineType
        state.timestamp = currentTimestamp()
      })
      .addCase(createNotification, (state, action) => {
        const { notification, account, timestamp } = action.payload
        if (!state.notifications[account]) {
          state.notifications[account] = {}
        }

        if (!state.notifications[account][timestamp]) {
          state.notifications[account][timestamp] = [notification]
        } else {
          state.notifications[account][timestamp].push(notification)
        }
      })
      .addCase(clearNotifications, (state, action) => {
        const { account } = action.payload
        delete state.notifications[account]
      })
      // .addCase(updateUserSingleHopOnly, (state, action) => {
      //   state.userSingleHopOnly = action.payload.userSingleHopOnly
      // })
      //     .addCase(addSerializedToken, (state, { payload: { serializedToken } }) => {
      //       state.tokens[serializedToken.chainId] = state.tokens[serializedToken.chainId] || {}
      //       state.tokens[serializedToken.chainId][serializedToken.address] = serializedToken
      //       state.timestamp = currentTimestamp()
      //     })
      //
      //     .addCase(removeSerializedToken, (state, { payload: { address, chainId } }) => {
      //       state.tokens[chainId] = state.tokens[chainId] || {}
      //       delete state.tokens[chainId][address]
      //       state.timestamp = currentTimestamp()
      //     })
      .addCase(updateUserPathType, (state, action) => {
        state.userPathType = action.payload.userPathType
        state.timestamp = currentTimestamp()
      })
      .addCase(addUserPath, (state, { payload: { address, chainId, symbol, name, decimals } }) => {
        if (!state.userPath[chainId]) {
          state.userPath[chainId] = {}
        }
        state.userPath[chainId][address.toLowerCase()] = {
          address,
          symbol,
          name,
          chainId,
          decimals,
        }
      })
      .addCase(removePath, (state, action: PayloadAction<RemoveCustomToken>) => {
        const { address, chainId } = action.payload
        if (state.userPath?.[chainId] && state.userPath[chainId]?.[address.toLowerCase()]) {
          delete state.userPath[chainId][address.toLowerCase()]
        }
      })
      .addCase(resetPath, (state, action: PayloadAction<{ chainId: ChainId }>) => {
        const { chainId } = action.payload

        state.userPath[chainId] = { ...initialState.userPath[chainId] }
      })
      .addCase(addPinnedToken, (state, { payload: { currencyId } }) => {
        Object.entries(state.pinnedTokens).forEach(([chainId, tokens]) => {
          if (!state.pinnedTokens[chainId]) {
            state.pinnedTokens[chainId] = tokens
          }
        })
        const [chainId, address] = currencyId.split(':')
        state.pinnedTokens[chainId] = Array.from(
          new Set([...state.pinnedTokens[chainId], `${chainId}:${getAddress(address)}`])
        )
      })
      .addCase(removePinnedToken, (state, { payload: { currencyId } }) => {
        const [chainId, address] = currencyId.split(':')
        state.pinnedTokens[chainId] = Array.from(
          new Set(
            state.pinnedTokens[chainId].filter(
              (token) => token !== `${chainId}:${getAddress(address)}`
            )
          )
        )
      })
      // .addCase(removePinnedToken, (state, action: PayloadAction<RemoveCustomToken>) => {
      //   const { address, chainId } = action.payload
      //   if (state.pinnedTokens?.[chainId] && state.pinnedTokens[chainId]?.[address.toLowerCase()]) {
      //     delete state.pinnedTokens[chainId][address.toLowerCase()]
      //   }
      // })
      .addCase(
        addCustomToken,
        (state, { payload: { address, chainId, symbol, name, decimals } }) => {
          if (!state.customTokens[chainId]) {
            state.customTokens[chainId] = {}
          }
          state.customTokens[chainId][address.toLowerCase()] = {
            address,
            symbol,
            name,
            chainId,
            decimals,
          }
        }
      )
      .addCase(addCustomTokens, (state, action: PayloadAction<TokenAsObject[]>) => {
        for (const item of action.payload) {
          const { address, symbol, name, chainId, decimals } = item
          if (!state.customTokens[chainId]) {
            state.customTokens[chainId] = {}
          }
          state.customTokens[chainId][address.toLowerCase()] = {
            address,
            symbol,
            name,
            chainId,
            decimals,
          }
        }
      })
      .addCase(removeCustomToken, (state, action: PayloadAction<RemoveCustomToken>) => {
        const { address, chainId } = action.payload
        if (state.customTokens[chainId] && state.customTokens[chainId][address.toLowerCase()]) {
          delete state.customTokens[chainId][address.toLowerCase()]
        }
      })
  // .addCase(addSerializedPair, (state, { payload: { serializedPair } }) => {
  //   if (
  //     serializedPair.token0.chainId === serializedPair.token1.chainId &&
  //     serializedPair.token0.address !== serializedPair.token1.address
  //   ) {
  //     const chainId = serializedPair.token0.chainId
  //     state.pairs[chainId] = state.pairs[chainId] || {}
  //     state.pairs[chainId][pairKey(serializedPair.token0.address, serializedPair.token1.address)] = serializedPair
  //   }
  //   state.timestamp = currentTimestamp()
  // })
  // .addCase(removeSerializedPair, (state, { payload: { chainId, tokenAAddress, tokenBAddress } }) => {
  //   if (state.pairs[chainId]) {
  //     // just delete both keys if either exists
  //     delete state.pairs[chainId][pairKey(tokenAAddress, tokenBAddress)]
  //     delete state.pairs[chainId][pairKey(tokenBAddress, tokenAAddress)]
  //   }
  //   state.timestamp = currentTimestamp()
  // })
  // .addCase(toggleURLWarning, (state) => {
  //   state.URLWarningVisible = !state.URLWarningVisible
  // })
  // .addCase(updateUserArcherUseRelay, (state, action) => {
  //   state.userArcherUseRelay = action.payload.userArcherUseRelay
  // })
  // .addCase(updateUserArcherGasPrice, (state, action) => {
  //   state.userArcherGasPrice = action.payload.userArcherGasPrice
  // })
  // .addCase(updateUserArcherETHTip, (state, action) => {
  //   state.userArcherETHTip = action.payload.userArcherETHTip
  // })
  // .addCase(updateUserArcherGasEstimate, (state, action) => {
  //   state.userArcherGasEstimate = action.payload.userArcherGasEstimate
  // })
  // .addCase(updateUserArcherTipManualOverride, (state, action) => {
  //   state.userArcherTipManualOverride = action.payload.userArcherTipManualOverride
  // })
)
